import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// 1. Import your specific .jpeg images here
import img1 from "../../../assets/img/portfolio/portfolio-col3-1.jpeg";
import img2 from "../../../assets/img/portfolio/portfolio-col3-2.jpeg";
import img3 from "../../../assets/img/portfolio/portfolio-col3-3.jpeg";
import img4 from "../../../assets/img/portfolio/portfolio-col3-4.jpeg";
import img5 from "../../../assets/img/portfolio/portfolio-col3-5.jpeg";
import img6 from "../../../assets/img/portfolio/portfolio-col3-6.jpeg";
import img7 from "../../../assets/img/portfolio/portfolio-col3-7.jpeg";
import img8 from "../../../assets/img/portfolio/portfolio-col3-8.jpeg";
// import img9 from "../../../assets/img/portfolio/portfolio-col3-9.jpeg";

// 2. Create the custom data array for this specific 3-column page
const customPortfolioData = [
    { id: "road-construction", image: img1, title: "Strong Construction", subtitle: "Civil Work" },
    { id: "drainage-system", image: img2, title: "Roof developement", subtitle: "Infrastructure" },
    { id: "pipeline-setup", image: img3, title: "Baundry Setup", subtitle: "Public Utility" },
    { id: "rcc-road", image: img4, title: "RCC Road Construction", subtitle: "Civil Work" },
    { id: "irrigation-line", image: img5, title: "Irrigation Line", subtitle: "Agriculture" },
    { id: "damar-road", image: img6, title: "Damar Road", subtitle: "Infrastructure" },
    { id: "beautification", image: img7, title: "Beautification", subtitle: "Urban Development" },
    { id: "renovation", image: img8, title: "Renovation", subtitle: "Public Utility" },
    // { id: "infrastructure", image: img9, title: "Public Infrastructure", subtitle: "Development" }
];

const showPortfolioItem = 6; // Shows 6 images initially (2 rows of 3)

const ThreeColumns = () => {
    // 3. Load the custom array into the state
    const [items, setItems] = useState(customPortfolioData);
    const [next, setNext] = useState(showPortfolioItem);
    
    const handleLoadData = () => {
        setNext(value => value + 3); // Loads 3 more images per click to keep the row balanced
    }

    return (
        <div className="three__columns section-padding-three">
            <div className="container">
                <div className="row">
                    {items?.slice(0, next)?.map((data, id) => (
                        <div className="col-lg-4 col-md-6 mt-25" key={id}>
                            <div className="portfolio__three-item">
                                {/* Added style to crop images perfectly to the same height */}
                                <img src={data.image} alt={data.title} style={{ width: '100%', height: '350px', objectFit: 'cover' }} />
                                <div className="portfolio__three-item-content">
                                    <Link to={`/portfolio/${data.id}`}><i className="flaticon flaticon-right-up"></i></Link>
                                    <span>{data.subtitle}</span>
                                    <h4><Link to={`/portfolio/${data.id}`}>{data.title}</Link></h4>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {next < items.length && (
                    <div className="row mt-70">
                        <div className="col-xl-12 t-center">
                            <button onClick={handleLoadData} className="build_button">Load More<i className="flaticon flaticon-right-up"></i></button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ThreeColumns;